module.exports = __webpack_public_path__ + "img/tooltip.5bf00257.svg";